import styled from "styled-components";
import Icon from "../../atoms/Icon/Icon";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "../../../store/Store";
import NotificationDropDown from "../notification/NotificationDropDown";
import { useEffect, useState } from "react";
import { SetTheme } from "../../../store/actions/general/GeneralActions";
import { StyledSpan } from "../../../styled";
import { clearLocalStorage } from "../../../utils/Helpers";
import LanguageSwitchButton from "src/components/molecules/languageSwitch/LanguageSwitchButton";
import { useTranslation } from "react-i18next";

const WrapperDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 52px;
  padding: 0 0 0 20px;
  background-color: ${(theme: any) => theme.theme.bgColor3};
`;
const LogoDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const ActionDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const UserDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 30px;
`;
const LeftDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const UsernameSpan = styled.span`
  color: ${(theme: any) => theme.theme.bgPrimary};
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  margin-inline-start: 10px;
`;
const WhiteLogoSpan = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 19px;
  /* identical to box height */

  text-align: center;

  /* Light / 1 */

  color: ${(theme: any) => theme.theme.white};
`;

const GreenEllipseWrapper = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 16px;
  height: 16px;
  background: ${(theme: any) => theme.theme.bgPrimary};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NotifPanelWrapper = styled.div`
  position: relative;
  cursor: pointer;
`;
const DesktopDashboardHeader: React.FC = () => {
  const {i18n} = useTranslation();
  const lng = i18n.language;
  const history = useHistory();
  const UserState = useSelector((state: RootStore) => state.user);
  const NotificationState = useSelector(
    (state: RootStore) => state.notification
  );
  const GeneralState = useSelector((state: RootStore) => state.general);
  const [showNotificationPanel, setShowNotificationPanel] = useState(false);
  const [mode, setMode] = useState(
    GeneralState.theme ? GeneralState.theme : "dark"
  );
  const dispatch = useDispatch();
  const handleClick = () => {
    clearLocalStorage();
    setTimeout(() => {
      window.location.href = "/app/login";
    }, 100);
  };

  const goToDashboard = () => {
    history.push("/");
  };

  const switchTxt = {
    leftTxt: "حالت شب",
    rightTxt: "حالت روز",
  };

  const handlePanelView = (side: string) => {
    if (side === "rightSide") {
      setMode("light");
      dispatch(SetTheme("light"));
    } else {
      setMode("dark");
      dispatch(SetTheme("dark"));
    }
  };

  const handleToggleNotifPanel = (e: any) => {
    e.stopPropagation();
    setShowNotificationPanel(!showNotificationPanel);
  };
  /**
   * Close Menu when clicked outside
   */
  useEffect(() => {
    document.addEventListener("click", () => {
      setShowNotificationPanel(false);
    });
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("click", () => {
        setShowNotificationPanel(false);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <WrapperDiv>
      <LogoDiv
        onClick={(e) => {
          goToDashboard();
        }}
      >
        <div style={{ width: "auto", marginRight: "30px" }}>
          {/* <Icon name={"mainLogo"} width={"auto"} height={"40px"} /> */}
          { lng === 'fa' ? 
            (<Icon name="mainLogo" width="auto" height="40px"></Icon>)
            :
            (<Icon name="mainLogoEn" width="auto" height="40px"></Icon>)
          }
        </div>
        {/* <WhiteLogoSpan>آنی‌زر</WhiteLogoSpan> */}
      </LogoDiv>
      <LeftDiv>
        {/* <SwitchButton
          activeSide={mode === "light" ? "rightSide" : "leftSide"}
          switchTxt={switchTxt}
          withIcon={true}
          leftIcon={"moon"}
          rightIcon={"sun"}
          width={"190px"}
          height={"47px"}
          onClick={handlePanelView}
        /> */}

        <NotificationDropDown
          onClose={() => setShowNotificationPanel(false)}
          show={showNotificationPanel}
        />
        <LanguageSwitchButton/>
        <UserDiv>
          <Icon name="personIcon" width="20px" height="20px" />
          <UsernameSpan>
            {UserState.user?.firstName} {UserState.user?.lastName}
          </UsernameSpan>
        </UserDiv>
        <ActionDiv>
          {/* <div
            onClick={() => history.push('/news')}
            style={{ cursor: 'pointer', margin: '0 10px' }}
          >
            <Icon name="news" width="32px" height="32px"></Icon>
          </div> */}
          <NotifPanelWrapper onClick={handleToggleNotifPanel}>
            <Icon name="notificationOff" width="32px" height="32px" />
            {NotificationState.unreadCount > 0 && (
              <GreenEllipseWrapper>
                <StyledSpan fontSize="10px" color="white" weight="500">
                  {NotificationState.unreadCount}
                </StyledSpan>
              </GreenEllipseWrapper>
            )}
          </NotifPanelWrapper>
          <div
            onClick={handleClick}
            style={{ cursor: "pointer", margin: "0 10px" }}
          >
            <Icon name="power" width="23px" height="23px" />
          </div>
        </ActionDiv>
      </LeftDiv>
    </WrapperDiv>
  );
};

export default DesktopDashboardHeader;
